import { Factory } from 'miragejs';

export default Factory.extend({
  // Protect Settings: sign-in/sign-out push notification reminders
  badgeSignInNotificationEnabled: true,
  signInReminderEnabled: true,
  signOutReminderEnabled: true,
  signInReminderAtMinutesSinceMidnight: 540,
  signOutReminderAtMinutesSinceMidnight: 1020,
});
